import Route from '@ember/routing/route';

export default class HotelRevenueInsightBreakdownDetailRoute extends Route {
  queryParams = {
    segmentationId: {
      refreshModel: true,
    },
  };
}
